import {
  NOTIFICATION_CATEGORIES,
  NOTIFICATION_DELIVERY_STATUSES,
  NOTIFICATION_DELIVERY_TIMINGS,
  NOTIFICATION_EVENT_TYPES,
} from '@steado/admin-contract/notifications';
import { z } from 'zod';

export const NOTIFICATION_WINDOWS = ['24h', '7d'] as const;
export type NotificationWindow = (typeof NOTIFICATION_WINDOWS)[number];

/**
 * Everything that shapes the screen lives in the URL, so "every failed
 * workout reminder" or one person's deliveries is a link somebody can paste.
 * `delivery` opens that delivery's drawer over the list.
 */
export const notificationsSearchSchema = z.object({
  /** Which side of now the list shows. Absent means what is due already. */
  when: z.enum(NOTIFICATION_DELIVERY_TIMINGS).optional().catch(undefined),
  search: z.string().optional().catch(undefined),
  status: z.enum(NOTIFICATION_DELIVERY_STATUSES).optional().catch(undefined),
  category: z.enum(NOTIFICATION_CATEGORIES).optional().catch(undefined),
  eventType: z.enum(NOTIFICATION_EVENT_TYPES).optional().catch(undefined),
  cursor: z.string().optional().catch(undefined),
  /** The metrics window. Absent means the last 24 hours. */
  window: z.enum(NOTIFICATION_WINDOWS).optional().catch(undefined),
  delivery: z.string().uuid().optional().catch(undefined),
});

export type NotificationsSearch = z.infer<typeof notificationsSearchSchema>;
